import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {KeyValuePair, PortalType} from "@payroll/optimus-common";
import Component from 'vue-class-component'
import {Action} from "vuex-class";
import SearchEmployer from '../customer-service/components/SearchEmployer.vue'
import SearchMember from '../customer-service/components/SearchMember.vue'


interface ArchiveDocsOpenerDocsProps {
  hasData: boolean
  isMember: boolean
  entityType: string
  name: string
  id: string
  accountList: KeyValuePair[]
  fundMap: any
  subjectList: KeyValuePair[]
  docTypeList: KeyValuePair[]
}

interface SelectedDocInfo {
  fund: KeyValuePair | null
  subject: KeyValuePair | null
  account: KeyValuePair | null
  documentType: KeyValuePair | null
  scanDate: Date | null
  correctDate: Date | null
  attachmentFile: any
}

@Component({
  components: {
    SearchMember,
    SearchEmployer
  }
})
export default class ArchiveDocumentsOpenerComponent extends AfterFetchComponent {

  @Action('getMemberDetails', StoreNamespace.ARCHIVE_DOCUMENTS_OPENER) getMemberDetails: any;
  @Action('getEmployerDetails', StoreNamespace.ARCHIVE_DOCUMENTS_OPENER) getEmployerDetails: any;
  @Action('createNewArchiveDocumentsOpener', StoreNamespace.ARCHIVE_DOCUMENTS_OPENER) createNewArchiveDocumentsOpener: any;

  private archiveDocsOpenerDocsProps: ArchiveDocsOpenerDocsProps = {
    hasData: false,
    isMember: false,
    entityType: "",
    name: "",
    id: "",
    accountList: [],
    fundMap: [],
    subjectList: [],
    docTypeList: []
  }

  private selectedDocInfo: SelectedDocInfo = {
    fund: null,
    subject: null,
    account: null,
    documentType: null,
    scanDate: new Date(),
    correctDate: new Date(),
    attachmentFile: []
  }

  private fundList: KeyValuePair[] = []
  private showSuccessPopup: boolean = false;
  private showErrorPopup: boolean = false;
  private currentEntityName: string = ""
  private currentEntityId: string = ""

  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'archiveDocumentsOpener/getMemberDetails':
        this.archiveDocsOpenerDocsProps = {
          ...data,
          hasData: true,
          isMember: true
        }
        break;
      case 'archiveDocumentsOpener/getEmployerDetails':
        this.archiveDocsOpenerDocsProps = {
          ...data,
          hasData: true,
          isMember: false
        }
        break;
      case 'archiveDocumentsOpener':
        if (data.result) {
          this.showSuccessPopup = true;
          this.currentEntityName = this.archiveDocsOpenerDocsProps.name
          this.currentEntityId = this.archiveDocsOpenerDocsProps.id

          this.resetData();
        } else {
          this.showErrorPopup = true
        }
    }
  }


  onError(messages: string[], code: number, requestName?: string): void {
    switch (requestName) {
      case 'archiveDocumentsOpener':
        this.showErrorPopup = true
        this.resetData();
        break;
    }
  }

  resetData() {
    this.selectedDocInfo = {
      fund: null,
      subject: null,
      account: null,
      documentType: null,
      scanDate: new Date(),
      correctDate: null,
      attachmentFile: []
    } as SelectedDocInfo

    this.archiveDocsOpenerDocsProps = {
      hasData: false,
      isMember: false,
      entityType: "",
      name: "",
      id: "",
      accountList: [],
      fundMap: new Map<string, KeyValuePair[]>(),
      subjectList: [],
      docTypeList: []
    } as ArchiveDocsOpenerDocsProps
  }

  onMemberSelection(row: any) {
    this.getMemberDetails({
      requestorCallback: this,
      pathVariable: row.id
    });
  }

  onEmployerSelection(row: any) {
    this.getEmployerDetails({
      requestorCallback: this,
      pathVariable: row.id
    });
  }

  onInputFile(file: any) {

  }

  onRemovedAttachmentClicked() {
    this.selectedDocInfo.attachmentFile = []
  }

  onSaveChanges() {
    let formData: FormData = new FormData()

    formData.append('file', this.selectedDocInfo.attachmentFile[0].file);
    if (this.selectedDocInfo.fund) {
      formData.append('fund', this.selectedDocInfo.fund.value)
    }
    if (this.selectedDocInfo.subject) {
      formData.append('subject', this.selectedDocInfo.subject.value)
    }
    if (this.selectedDocInfo.account) {
      formData.append('account', this.selectedDocInfo.account.value)
    }
    if (this.selectedDocInfo.documentType) {
      formData.append('documentType', this.selectedDocInfo.documentType.value);
    }
    if (this.selectedDocInfo.scanDate) {
      formData.append('scanDate', this.formatDate(this.selectedDocInfo.scanDate));
    }
    if (this.selectedDocInfo.correctDate) {
      formData.append('correctDate', this.formatDate(this.selectedDocInfo.correctDate));
    }

    const portalType = this.archiveDocsOpenerDocsProps.isMember ? PortalType.MEMBER : PortalType.EMPLOYER
    formData.append("portalType", portalType)

    this.createNewArchiveDocumentsOpener({
      requestorCallback: this,
      formData
    })
  }

  private formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }


  private minutesLeftUntilNextTwenty() {
    const now = new Date();
    const currentMinutes = now.getMinutes();
    const nextTwenty = Math.ceil(currentMinutes / 20) * 20;

    // Handle the case where current minutes are already a multiple of 20
    if (nextTwenty === currentMinutes) {
      return 0;
    }

    return nextTwenty - currentMinutes;
  }

  private showErrorMessage: boolean = false;

  updateModel(selected: any) {

    if (this.archiveDocsOpenerDocsProps.fundMap[selected.value]) {
      this.fundList = [];
      setTimeout(() => {
        this.fundList = this.archiveDocsOpenerDocsProps.fundMap[selected.value]
      }, 100);
    }
  }
}